import dayjs from "dayjs";

import { RewardsModel } from "../../../models/Rewards.model";
import { RewardPathType } from "../../RewardTabs/RewardTabs.types";

type RewardType = keyof RewardsModel;

export const TENANT_TYPE_OPTIONS = [
  { label: 'Partner', value: 'PARTNER' },
  { label: 'Store', value: 'STORE' },
];

export function getTenantTypeValue(value: any): 'PARTNER' | 'STORE' | undefined {
  if (!value) return undefined;
  if (typeof value === 'string') return value.toUpperCase() as 'PARTNER' | 'STORE';
  if (typeof value === 'object' && value.value) return String(value.value).toUpperCase() as 'PARTNER' | 'STORE';
  return undefined;
}

export function getEnabledFields(type?: RewardPathType, status?: string, isGamification?: boolean) {

  const _status = status?.toLowerCase();

  if (type === 'birthday-gift') {
    switch (_status) {
      case 'active':
      case 'inactive':
        return [
          'reward_name',
          'voucher_value',
          'tenant_type',
          'partners',
          'merchant_categories',
          'merchants',
          'program_name',
          'reward_tnc_en',
          'reward_tnc_id',
          'days',
          'validity_period_days',
          'reward_banner_image'
        ] as RewardType[];
    }
    return undefined;
  }

  switch (_status) {
    case 'active':
    case 'inactive': {
      const fields: RewardType[] = [
        'reward_name',
        'voucher_value',
        'tenant_type',
        'partners',
        'merchant_categories',
        'merchants',
        'reward_quota',
        'reward_end_date',
        'reward_tnc_en',
        'reward_tnc_id',
        'days',
        'reward_start_time',
        'reward_end_time',
        'valid_until',
        'validity_period_days',
        'redemption_attempt',
        'max_redemption',
        'reward_banner_image',
        'program_name',
        'is_show_in_list',
        'is_gamification'
      ];

      if (!isGamification) {
        fields.push(
          'is_buyable',
          'point',
          'is_buyable_point',
          'reward_price'
        );
      }

      return fields;
    }
  }
  return undefined;
}

export function isApplicableGamificationReward(type?: string): boolean {
  return ['e-voucher', 'physical-voucher', 'free-parking', 'DIGITAL', 'FISIK', 'PARKING'].includes(type || '');
}

export function isRewardUsedInGamification(reward?: RewardsModel): boolean {
  if (!reward) return false;
  return Boolean(
    reward.is_used_by_gamification ||
    reward.is_used_in_gamification ||
    reward.is_gamification_used ||
    (reward as any).is_used ||
    (reward as any).used_in_gamification
  );
}

export function validateAmount(value = 0) {
  if (value > 9999) {
    return 'Maximum amount is 9.999';
  }
  return true;
}

export function validateQuota(value = 0, total = 0, remaining = 0, disableValidation?: boolean) {
  const used = total - remaining

  return (value: number) => {
    if (disableValidation) return true


    if (value < used) {
      return `New quota cannot be less than redeemed quota (${used})`;
    }

    return true;
  }
}

export function validateMaxDaysOfUse(type: RewardPathType | undefined, diff: number, date?: string) {
  return (value: number) => {
    if (type === 'birthday-gift') {
      diff = dayjs(date).daysInMonth();
    }
    if (+value > diff) {
      return `Maximum day is ${diff}`;
    }
    if (+value < 1) {
      return "Minimal day is 1";
    }
    return (true);
  }
}

export function validateRedemption(value = 0) {
  if (value < 1) {
    return 'Minimal is 1';
  }
  if (value > 9999) {
    return 'Maximum is 9.999';
  }
  return true;
}

export function validatePercentage(value = 0, isSubmited: boolean) {
  if (!isSubmited) { return false }
  if (value === undefined || value === null || value < 0 || value > 100) {
    return true;
  }
  return false;
}

export function validatePercentageMsg(value = 0, isSubmited: boolean) {
  if (!isSubmited) { return '' }
  if (value === undefined || value === null) {
    return 'Field cannot be empty.';
  }
  if (value < 0) {
    return 'Minimal is 0';
  }
  if (value > 100) {
    return 'Maximum is 100';
  }
  return '';
}

export function validateRequired(value: string | number = '', isSubmited: boolean) {
  if (!isSubmited) { return false }
  return value === undefined || value === null || value === '';
}

export function validateRequiredMsg(value: string | number = '', isSubmited: boolean) {
  if (!isSubmited) { return '' }
  return value === undefined || value === null || value === ''
    ? 'Field cannot be empty.'
    : '';
}
